export class FileFormat {
    ID: number;
    Name: string;
}

export default FileFormat;